/* tslint:disable */
/* eslint-disable */
/**
 * Relays-Online
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddTrainingNodeCommand,
    AddTrainingNodeCommandFromJSON,
    AddTrainingNodeCommandToJSON,
    ArticleDto,
    ArticleDtoFromJSON,
    ArticleDtoToJSON,
    DeleteNodeCommand,
    DeleteNodeCommandFromJSON,
    DeleteNodeCommandToJSON,
    NodeDto,
    NodeDtoFromJSON,
    NodeDtoToJSON,
    NodeVm,
    NodeVmFromJSON,
    NodeVmToJSON,
    SendFeedbackCommand,
    SendFeedbackCommandFromJSON,
    SendFeedbackCommandToJSON,
    UpdateArticleCommand,
    UpdateArticleCommandFromJSON,
    UpdateArticleCommandToJSON,
    UpdateTrainingNodeCommand,
    UpdateTrainingNodeCommandFromJSON,
    UpdateTrainingNodeCommandToJSON,
} from '../models';

export interface ApiTrainingArticleIdGetRequest {
    id: number;
}

export interface ApiTrainingArticlePutRequest {
    updateArticleCommand?: UpdateArticleCommand;
}

export interface ApiTrainingArticlesGetRequest {
    nodeId?: string | null;
    training?: boolean | null;
    getRecent?: number | null;
}

export interface ApiTrainingFeedbackPostRequest {
    sendFeedbackCommand?: SendFeedbackCommand;
}

export interface ApiTrainingNodeDeleteRequest {
    deleteNodeCommand?: DeleteNodeCommand;
}

export interface ApiTrainingNodeGetRequest {
    id?: string;
    training?: boolean | null;
}

export interface ApiTrainingNodePostRequest {
    addTrainingNodeCommand?: AddTrainingNodeCommand;
}

export interface ApiTrainingNodePutRequest {
    updateTrainingNodeCommand?: UpdateTrainingNodeCommand;
}

export interface ApiTrainingNodesGetRequest {
    training?: boolean | null;
}

export interface ApiTrainingNodesRootsGetRequest {
    training?: boolean | null;
}

/**
 * 
 */
export class TrainingApi extends runtime.BaseAPI {

    /**
     */
    async apiTrainingArticleIdGetRaw(requestParameters: ApiTrainingArticleIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticleDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiTrainingArticleIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/article/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticleDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiTrainingArticleIdGet(requestParameters: ApiTrainingArticleIdGetRequest, initOverrides?: RequestInit): Promise<ArticleDto> {
        const response = await this.apiTrainingArticleIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingArticlePutRaw(requestParameters: ApiTrainingArticlePutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticleDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Article`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateArticleCommandToJSON(requestParameters.updateArticleCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticleDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiTrainingArticlePut(requestParameters: ApiTrainingArticlePutRequest, initOverrides?: RequestInit): Promise<ArticleDto> {
        const response = await this.apiTrainingArticlePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingArticlesGetRaw(requestParameters: ApiTrainingArticlesGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ArticleDto>>> {
        const queryParameters: any = {};

        if (requestParameters.nodeId !== undefined) {
            queryParameters['NodeId'] = requestParameters.nodeId;
        }

        if (requestParameters.training !== undefined) {
            queryParameters['Training'] = requestParameters.training;
        }

        if (requestParameters.getRecent !== undefined) {
            queryParameters['GetRecent'] = requestParameters.getRecent;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Articles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ArticleDtoFromJSON));
    }

    /**
     */
    async apiTrainingArticlesGet(requestParameters: ApiTrainingArticlesGetRequest, initOverrides?: RequestInit): Promise<Array<ArticleDto>> {
        const response = await this.apiTrainingArticlesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingFeedbackPostRaw(requestParameters: ApiTrainingFeedbackPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Feedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendFeedbackCommandToJSON(requestParameters.sendFeedbackCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiTrainingFeedbackPost(requestParameters: ApiTrainingFeedbackPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiTrainingFeedbackPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiTrainingGetSearchKeyGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/GetSearchKey`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiTrainingGetSearchKeyGet(initOverrides?: RequestInit): Promise<string> {
        const response = await this.apiTrainingGetSearchKeyGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingNodeDeleteRaw(requestParameters: ApiTrainingNodeDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Node`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteNodeCommandToJSON(requestParameters.deleteNodeCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiTrainingNodeDelete(requestParameters: ApiTrainingNodeDeleteRequest, initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.apiTrainingNodeDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingNodeGetRaw(requestParameters: ApiTrainingNodeGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NodeDto>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['Id'] = requestParameters.id;
        }

        if (requestParameters.training !== undefined) {
            queryParameters['Training'] = requestParameters.training;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Node`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NodeDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiTrainingNodeGet(requestParameters: ApiTrainingNodeGetRequest, initOverrides?: RequestInit): Promise<NodeDto> {
        const response = await this.apiTrainingNodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingNodePostRaw(requestParameters: ApiTrainingNodePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Node`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddTrainingNodeCommandToJSON(requestParameters.addTrainingNodeCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiTrainingNodePost(requestParameters: ApiTrainingNodePostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiTrainingNodePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiTrainingNodePutRaw(requestParameters: ApiTrainingNodePutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<NodeVm>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Node`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTrainingNodeCommandToJSON(requestParameters.updateTrainingNodeCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NodeVmFromJSON));
    }

    /**
     */
    async apiTrainingNodePut(requestParameters: ApiTrainingNodePutRequest, initOverrides?: RequestInit): Promise<Array<NodeVm>> {
        const response = await this.apiTrainingNodePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingNodesGetRaw(requestParameters: ApiTrainingNodesGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<NodeVm>>> {
        const queryParameters: any = {};

        if (requestParameters.training !== undefined) {
            queryParameters['Training'] = requestParameters.training;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Nodes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NodeVmFromJSON));
    }

    /**
     */
    async apiTrainingNodesGet(requestParameters: ApiTrainingNodesGetRequest, initOverrides?: RequestInit): Promise<Array<NodeVm>> {
        const response = await this.apiTrainingNodesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingNodesRootsGetRaw(requestParameters: ApiTrainingNodesRootsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<NodeDto>>> {
        const queryParameters: any = {};

        if (requestParameters.training !== undefined) {
            queryParameters['Training'] = requestParameters.training;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/Nodes/roots`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NodeDtoFromJSON));
    }

    /**
     */
    async apiTrainingNodesRootsGet(requestParameters: ApiTrainingNodesRootsGetRequest, initOverrides?: RequestInit): Promise<Array<NodeDto>> {
        const response = await this.apiTrainingNodesRootsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingPublishArticlesGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<NodeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/PublishArticles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NodeDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiTrainingPublishArticlesGet(initOverrides?: RequestInit): Promise<NodeDto> {
        const response = await this.apiTrainingPublishArticlesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTrainingRetrieveArticlesGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<NodeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Training/RetrieveArticles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NodeDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiTrainingRetrieveArticlesGet(initOverrides?: RequestInit): Promise<NodeDto> {
        const response = await this.apiTrainingRetrieveArticlesGetRaw(initOverrides);
        return await response.value();
    }

}
